// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    PanelLeftOpen,
    PanelLeftRightDashed,
    PanelRight,
    PanelRightClose,
    PanelRightDashed,
    PanelRightOpen,
    PanelTop,
    PanelTopBottomDashed,
    PanelTopClose,
    PanelTopDashed,
    PanelTopOpen,
    PanelsLeftBottom,
    PanelsRightBottom,
    PanelsTopLeft,
    PaperBag,
    Paperclip,
    Parasol,
    Parentheses,
    ParkingMeter,
    PartyPopper,
    Pause,
    PawPrint,
    PcCase,
    Pen,
    PenLine,
    PenOff,
    PenTool,
    Pencil,
    PencilLine,
    PencilOff,
    PencilRuler,
    PencilSparkles,
    Pentagon,
    Percent,
    PersonStanding,
    Phi,
    PhilippinePeso,
    Phone,
    PhoneCall,
    PhoneForwarded,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "panel-left-open" through "phone-forwarded", inclusive. */
const shard: Record<string, LucideIcon> = {
    "panel-left-open": PanelLeftOpen,
    "panel-left-right-dashed": PanelLeftRightDashed,
    "panel-right": PanelRight,
    "panel-right-close": PanelRightClose,
    "panel-right-dashed": PanelRightDashed,
    "panel-right-open": PanelRightOpen,
    "panel-top": PanelTop,
    "panel-top-bottom-dashed": PanelTopBottomDashed,
    "panel-top-close": PanelTopClose,
    "panel-top-dashed": PanelTopDashed,
    "panel-top-open": PanelTopOpen,
    "panels-left-bottom": PanelsLeftBottom,
    "panels-right-bottom": PanelsRightBottom,
    "panels-top-left": PanelsTopLeft,
    "paper-bag": PaperBag,
    paperclip: Paperclip,
    parasol: Parasol,
    parentheses: Parentheses,
    "parking-meter": ParkingMeter,
    "party-popper": PartyPopper,
    pause: Pause,
    "paw-print": PawPrint,
    "pc-case": PcCase,
    pen: Pen,
    "pen-line": PenLine,
    "pen-off": PenOff,
    "pen-tool": PenTool,
    pencil: Pencil,
    "pencil-line": PencilLine,
    "pencil-off": PencilOff,
    "pencil-ruler": PencilRuler,
    "pencil-sparkles": PencilSparkles,
    pentagon: Pentagon,
    percent: Percent,
    "person-standing": PersonStanding,
    phi: Phi,
    "philippine-peso": PhilippinePeso,
    phone: Phone,
    "phone-call": PhoneCall,
    "phone-forwarded": PhoneForwarded,
};

export default shard;
